import React from 'react';
import { Input, Label, Select_simple } from "./ui";

const TabII_Legal_Social = ({ data, onChange }) => {

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        // Manejo para radio buttons y checkboxes si fuera necesario
        const val = type === 'checkbox' ? checked : value;
        onChange({ ...data, [name]: val });
    };

    return (
        <div className="space-y-8 p-4 bg-white rounded-lg border border-slate-100">
            
            {/* --- 1. PERSONERÍA JURÍDICA --- */}
            <section className="space-y-6">
                <h3 className="text-lg font-bold text-emerald-800 border-b pb-2">
                    Situación Institucional y Personería Jurídica
                </h3>
                
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                    <Label className="text-base mb-3 block">¿La entidad cuenta con personería jurídica vigente?</Label>
                    <div className="flex gap-6">
                        {['Sí', 'No', 'En trámite'].map((opcion) => (
                            <label key={opcion} className="flex items-center gap-2 cursor-pointer group">
                                <input 
                                    type="radio" 
                                    name="personeria_vigente" 
                                    value={opcion}
                                    checked={data.personeria_vigente === opcion}
                                    onChange={handleChange}
                                    className="w-4 h-4 text-emerald-600 focus:ring-emerald-500"
                                />
                                <span className="text-sm font-medium text-slate-700 group-hover:text-emerald-700">{opcion}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* --- CAMPOS CONDICIONALES (SI LA RESPUESTA ES "SÍ") --- */}
                {data.personeria_vigente === 'Sí' && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in slide-in-from-top-2 duration-300">
                        <div className="md:col-span-2">
                            <Label>Denominación registrada (conforme personería jurídica)</Label>
                            <Input name="denominacion_registrada" value={data.denominacion_registrada || ''} onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Número de matrícula o resolución</Label>
                            <Input name="nro_matricula" value={data.nro_matricula || ''} onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Organismo otorgante</Label>
                            <Select_simple 
                                name="organismo_otorgante" 
                                value={data.organismo_otorgante || ''} 
                                onChange={handleChange}
                                options={[{ value: 'DPPJ', label: 'Dirección Provincial de Personas Jurídicas' }]}
								placeholder="Seleccionar..."
                            />
                        </div>
                        <div>
                            <Label>Estado actual ante la DPPJ</Label>
                            <Select_simple 
                                name="estado_dppj" 
                                value={data.estado_dppj || ''} 
                                onChange={handleChange}
                                options={[
                                    { value: 'Activa', label: 'Activa' },
                                    { value: 'Regularizacion', label: 'En proceso de regularización' },
                                    { value: 'Intimaciones', label: 'Con intimaciones pendientes' }
                                ]}
                                placeholder="Seleccionar..."
                            />
                        </div>
                        <div>
                            <Label>Fecha de la última renovación de autoridades</Label>
                            <Input type="date" name="fecha_renovacion" value={data.fecha_renovacion || ''} onChange={handleChange} />
                        </div>
                    </div>
                )}
            </section>

            {/* --- 2. AUTORIDADES Y SOCIOS --- */}
            <section className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4">
                <div className="space-y-4">
                    <h3 className="text-md font-bold text-slate-800 uppercase tracking-wider">Autoridades Vigentes</h3>
                    <div className="space-y-3">
                        <div><Label className="text-xs">Presidente/a</Label><Input name="presi_nombre" value={data.presi_nombre || ''} onChange={handleChange} /></div>
                        <div><Label className="text-xs">Secretario/a</Label><Input name="secre_nombre" value={data.secre_nombre || ''} onChange={handleChange} /></div>
                        <div><Label className="text-xs">Tesorero/a</Label><Input name="teso_nombre" value={data.teso_nombre || ''} onChange={handleChange} /></div>
                    </div>
                </div>

                <div className="space-y-4">
                    <h3 className="text-md font-bold text-slate-800 uppercase tracking-wider">Cantidad aprox. de socios</h3>
                    <div className="grid grid-cols-3 gap-2">
                        <div><Label className="text-[10px]">Activos</Label><Input type="number" name="socios_activos" value={data.socios_activos || ''} onChange={handleChange} /></div>
                        <div><Label className="text-[10px]">Vitalicios</Label><Input type="number" name="socios_vitalicios" value={data.socios_vitalicios || ''} onChange={handleChange} /></div>
                        <div><Label className="text-[10px]">Infantiles</Label><Input type="number" name="socios_infantiles" value={data.socios_infantiles || ''} onChange={handleChange} /></div>
                    </div>
                </div>
            </section>

            {/* --- 3. LIBROS SOCIALES --- */}
            <section className="space-y-4 pt-4">
                <h3 className="text-md font-bold text-slate-800 border-l-4 border-emerald-500 pl-2">
                    ¿La institución cuenta con libros sociales rubricados y actualizados?
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-emerald-50/50 p-4 rounded-lg">
                    {[
                        { id: 'libro_actas_asamblea', label: 'Libro de Actas de Asamblea' },
                        { id: 'libro_actas_cd', label: 'Libro de Actas de Comisión' },
                        { id: 'libro_registro_socios', label: 'Libro de Registro de Socios' }
                    ].map((libro) => (
                        <label key={libro.id} className="flex items-center gap-3 cursor-pointer">
                            <input 
                                type="checkbox" 
                                name={libro.id} 
                                checked={data[libro.id] || false} 
                                onChange={handleChange}
                                className="w-5 h-5 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
                            />
                            <span className="text-sm text-slate-700">{libro.label}</span>
                        </label>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default TabII_Legal_Social;